<template>
  <b-modal
    title="Inserimento Modalità Relazionali"
    class="modal-info registro"
    v-model="show1"
    ok-variant="danger"
    :ok-only="true"
    size="xl"
  >
    <div>
      <div v-if="!mydata.istut && !mydata.isdoc">
        <div style="float: left" v-if="mydata.aid==0">
          <table class="insmodrel">
            <tr><td colspan=2>Non hanno votato</td></tr>
            <tr v-for="d in novoto" :key="d.id">
              <td>{{d.nome}}</td>
              <td class="grafico">-</td>
            </tr>
          </table>
        </div>
        <div style="float: left" v-if="mydata.aid>0">
          <table class="insmodrel">
            <tr v-for="d in novoto" :key="d.id">
              <td>{{d.nome}}</td>
              <td class="grafico">-</td>
            </tr>
            <tr v-for="d in sivoto" :key="d.dnome">
              <td>{{d.dnome}}</td>
              <td class="grafico">
                <peity :type="'bar'" :options="baropts(d)" :data="bardata(d).toString()"></peity>
              </td>
            </tr>
          </table>
        </div>
        <div style="float: left;margin-left: 40px;" v-if="mydata.aid>0">
          <table>
            <tr><td>Atteggiamento:</td><td style="background-color: red;width:30px;">&nbsp;</td></tr>
            <tr><td>Partecipazione:</td><td style="background-color: white;">&nbsp;</td></tr>
            <tr><td>Consegne:</td><td style="background-color: blue;">&nbsp;</td></tr>
            <tr><td>Materiale:</td><td style="background-color: orange;">&nbsp;</td></tr>
            <tr><td>Regolamento:</td><td style="background-color: yellow;">&nbsp;</td></tr>
          </table>
        </div>
      </div>
      <table class="insmodrel" v-if="mydata.istut">
        <tr v-for="domanda in domandetutor" :key="domanda.id">
          <td :rowspan="rowspan(domanda)" v-if="domanda.dom.sottogruppo==1">{{domanda.dom.gruppo}}</td>
          <td :class="bgcol(domanda)">
            <multiselect
              v-model="domanda.v"
              :options="domanda.opts"
              :multiple="false"
              :close-on-select="true"
              label="testo"
              track-by="id"
              :disabled="false"
            ></multiselect>
          </td>
        </tr>
      </table>
      <table class="insmodrel" v-if="mydata.isdoc">
        <tr>
          <td colspan="2">
            <b>Con i formatori</b>
          </td>
        </tr>
        <tr v-for="domanda in domandeform" :key="domanda.id">
          <td :rowspan="rowspan(domanda)" v-if="domanda.dom.sottogruppo==1">{{domanda.dom.gruppo}}</td>
          <td :class="bgcol(domanda)">
            <multiselect
              v-model="domanda.v"
              :options="domanda.opts"
              :multiple="false"
              :close-on-select="true"
              label="testo"
              track-by="id"
              :disabled="false"
            ></multiselect>
          </td>
        </tr>
        <tr>
          <td colspan="2">
            <b>Con i compagni</b>
          </td>
        </tr>
        <tr v-for="domanda in domandecomp" :key="domanda.id">
          <td :rowspan="rowspan(domanda)" v-if="domanda.dom.sottogruppo==1">{{domanda.dom.gruppo}}</td>
          <td :class="bgcol(domanda)">
            <multiselect
              v-model="domanda.v"
              :options="domanda.opts"
              :multiple="false"
              :close-on-select="true"
              label="testo"
              track-by="id"
              :disabled="false"
            ></multiselect>
          </td>
        </tr>
      </table>
    </div>
    <div slot="modal-footer" style="width: 100%;">
      <div style="float: right;margin-left: 10px;" v-if="!mydata.istut && !mydata.isdoc">
        <button
          type="button"
          class="btn btn-info"
          @click="show1=false"
          title="Chiudi"
        >
          Chiudi
        </button>
      </div>
      <div style="float: left;" v-if="mydata.istut || mydata.isdoc">
        <button type="button" class="btn btn-danger" @click="show1=false">Annulla</button>
      </div>
      <div style="float: right;margin-left: 10px;" v-if="mydata.istut || mydata.isdoc">
        <button
          type="button"
          class="btn btn-info"
          @click="addvoto()"
          :disabled="!validvoto"
          title="Salva"
          v-if="cansave"
        >
          Salva
          <i class="fa fa-check"></i>
        </button>
      </div>
      <div style="clear: both;"></div>
    </div>
  </b-modal>
</template>
<script>
import { API } from "@/api.js";
import Peity from "vue-peity";
import { DateTime } from "luxon";

export default {
  name: "InsModRel",
  mixins: [window.myMixin],
  components: {
    Peity
  },
  data: function() {
    return {
      show1: false,
      domandeform: [],
      domandecomp: [],
      domandetutor: [],
      novoto: [],
      sivoto: [],
      kgrp: {},
      show1: false,
      mydata: {}
    };
  },
  props: ["show", "value"],
  mounted: async function() {
    this.init();
  },
  watch: {
    show: function(newVal, oldVal) {
      this.show1 = newVal;
    },
    show1: function(newVal, oldVal) {
      if (!newVal) {
        this.mydata.show = false;
        this.$emit("input", this.mydata); // questo emit si aggancia come v-model
      }
    },
    value: function(newVal, oldVal) {
      // console.log("Prop value changed: ", newVal, " | was: ", oldVal);
      this.mydata = Object.assign({}, newVal);
      this.init();
    }
  },
  computed: {
    test: function(){
      return DateTime.local()
        .plus({ days: 1 })
        .toISODate() < window.FORMVOTIALUNNI_DATAFINESEM
    },
    cansave: function(){
      if(this.test)
        return this.mydata.mese<2 || this.mydata.mese>=9
      else
        return this.mydata.mese>=2 && this.mydata.mese<9
    },
    validvoto: function() {
      // console.log("validvoto", this.domandeform);
      var ok = true;
      if (this.mydata.isdoc) {
        this.domandeform.map(d => {
          ok = ok & (d.v !== false);
        });
        // console.log("validvoto1", ok);
        this.domandecomp.map(d => {
          ok = ok & (d.v !== false);
        });
      }
      if (this.mydata.istut) {
        // console.log("validvoto2", ok);
        this.domandetutor.map(d => {
          ok = ok & (d.v !== false);
        });
      }
      // console.log("validvoto3", ok);
      // console.log("validvoto")
      return ok;
    }
  },
  methods: {
    bardata: function(d) {
      // console.log("BARDATA", d);
      if (d.dnome == "TUTOR") {
        var ret = (d.voti.Regolamento / 34.0) * 100;
        console.log("RET", ret);
        return ret;
      } else {
        var grps = ["Atteggiamento", "Partecipazione", "Consegne", "Materiale"];
        var divs = [12.0, 24.0, 10.0, 20.0];
        var ret = [0, 0, 0, 0];
        grps.forEach((g, i) => {
          ret[i] = (d.voti[g] / divs[i]) * 100;
        });
        console.log("RET", ret);
        return ret;
      }
    },
    baropts: function(d) {
      if (d.dnome == "TUTOR")
        return {
          fill: ["yellow"],
          width: 50,
          height: 25,
          max: 100
        };
      else
        return {
          fill: ["red", "white", "blue", "orange"],
          width: 50,
          height: 25,
          max: 100
        };
    },
    bgcol: function(domanda) {
      if (domanda && domanda.v) return "bgcol" + domanda.v.ranking;
      else return "";
    },
    init: async function() {
      this.domandeform = [];
      this.domandecomp = [];
      this.domandetutor = [];

      this.sivoto = [];
      var dnome = "";
      var k = -1;
      var ret = await API.sqlprep(this, "modrel.votimodreldett", [
        this.mydata.aid,
        this.mydata.mese
      ]);
      ret.data.dati.forEach(e => {
        if (e.dnome != dnome) {
          dnome = e.dnome;
          this.sivoto.push({ dnome: dnome, voti: {} });
          k++;
        }
        this.sivoto[k].voti[e.gruppo] = e.v;
      });

      var ret = await API.sqlprep(this, "modrel.seldomande", []);
      var domandeform = [];
      var domandecomp = [];
      var domandetutor = [];
      var tmp = {};
      var kgrp = {};
      var obj;
      ret.data.dati.forEach(e => {
        if (!tmp["a" + e.tutor + e.versoform + e.gruppo + e.sottogruppo]) {
          obj = [];
          var d = { dom: e, v: false, opts: obj };
          if (e.tutor) domandetutor.push(d);
          else if (e.versoform) domandeform.push(d);
          else domandecomp.push(d);
          tmp["a" + e.tutor + e.versoform + e.gruppo + e.sottogruppo] = true;
        }
        obj.push(e);

        kgrp["a" + e.tutor + e.versoform + e.gruppo] = e.sottogruppo;
      });
      // imposto i valori preesistenti (se ne ho )
      ret = await API.sqlprep(this, "modrel.getvalut", [
        this.mydata.aid,
        this.mydata.mese,
        this.mydata.did
      ]);
      ret = ret.data.dati;
      if (this.mydata.istut) {
        var ret2 = await API.sqlprep(this, "modrel.getvalut", [
          this.mydata.aid,
          this.mydata.mese,
          0
        ]);
        ret2 = ret2.data.dati;
        ret = ret.concat(ret2);
      }
      if (ret.length == 0) {
        // provo con il mese prima
        var m = this.mydata.mese;
        if (m > 9 || m > 1) m = m - 1;
        else if (m == 1) m = 12;
        else m = false;

        if (m !== false) {
          ret = await API.sqlprep(this, "modrel.getvalut", [
            this.mydata.aid,
            m,
            this.mydata.did
          ]);
          ret = ret.data.dati;
          if (this.mydata.istut) {
            var ret2 = await API.sqlprep(this, "modrel.getvalut", [
              this.mydata.aid,
              m,
              0
            ]);
            ret2 = ret2.data.dati;
            ret = ret.concat(ret2);
          }
        }
      }
      ret = ret.map(r => r.modrelid);
      console.log("valut", ret);
      domandeform.map(d => {
        d.opts.forEach(o => {
          if (ret.indexOf(o.id) >= 0) d.v = o;
        });
      });
      domandecomp.map(d => {
        d.opts.forEach(o => {
          if (ret.indexOf(o.id) >= 0) d.v = o;
        });
      });
      domandetutor.map(d => {
        d.opts.forEach(o => {
          if (ret.indexOf(o.id) >= 0) d.v = o;
        });
      });
      //prendo i nomi di tutti quelli che non hanno votato
      var docs;
      if (this.mydata.aid == 0) {
        ret = await API.sqlprep(this, "modrel.novoti", [
          this.mydata.pid,
          this.mydata.mese
        ]);
        docs = ret.data.dati;
      } else {
        ret = await API.sqlprep(this, "modrel.docincs", [
          ORE_THRESHOLD,
          this.mydata.pid,
          this.mydata.pid,
          this.mydata.pid
        ]);
        docs = ret.data.dati;
        console.log("DOCS1:", docs);
        ret = await API.sqlprep(this, "modrel.getvalut2", [
          this.mydata.aid,
          this.mydata.mese
        ]);
        var dv = ret.data.dati;
        console.log("VALS1:", dv);
        docs = docs
          .map(d => {
            if (dv.find(v => v.docid == d.docenteid)) d.nome = false;
            if (d.doc == 0) d.nome = false;
            return d;
          })
          .map(d => {
            if (d.doc == 0) d.nome = "TUTOR";
            return d;
          })
          .filter(d => d.nome)
      }
      docs.sort((a, b) => {
        if (a.nome < b.nome) return -1;
        else if (a.nome > b.nome) return 1;
        else return 0;
      });
      console.log("DOCS2:", docs);
      this.novoto = docs;

      this.domandeform = domandeform;
      this.domandecomp = domandecomp;
      this.domandetutor = domandetutor;
      // console.log("INIT",this.mydata,domandeform,domandecomp,domandetutor,ret)
      this.kgrp = kgrp;
    },
    rowspan: function(e) {
      return this.kgrp["a" + e.dom.tutor + e.dom.versoform + e.dom.gruppo];
    },
    async addvoto(hm) {
      // console.log("EMIT...");
      this.mydata.form = this.domandeform;
      this.mydata.comp = this.domandecomp;
      this.mydata.tutor = this.domandetutor;
      this.mydata.cancel = false;
      this.mydata.show = false;
      this.$emit("input", this.mydata); // questo emit si aggancia come v-model
    }
  }
};
</script>
<style scoped>
</style>
<style>
table.insmodrel div.multiselect {
  min-width: 600px;
}
table.insmodrel td {
  border: thin solid black;
}
table.insmodrel td.grafico {
  padding: 3px;
  background-color: lightblue;
  width: 55px;
  text-align: center;
}
table.insmodrel td div.multiselect__tags {
  background-color: rgba(0, 0, 0, 0);
}
table.insmodrel td.bgcol1 {
  background-color: green;
}
table.insmodrel td.bgcol2 {
  background-color: orange;
}
table.insmodrel td.bgcol3 {
  background-color: orangered;
}
</style>